import React, { useCallback, useEffect, useState } from "react";
import { useError } from "../../../context/errorContext";
import axiosInstance from "../../../api/axiosInstance";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import LockClockRoundedIcon from '@mui/icons-material/LockClockRounded';
import DomainDisabledRoundedIcon from '@mui/icons-material/DomainDisabledRounded';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import useEntity from "../../../api/useEntity";
import EditModal from "../../../components/editModal/editModal";
import ChangeApiPermissions from "../../../components/changeApiPermissions/changeApiPermissions";
import moment from 'moment';
import "./apiKeys.scss"

const ApiKeys = () => {
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showKey, setShowKey] = useState(null);
    const [changeAccessRights, setChangeAccessRights] = useState(false);

    const fetchData = useCallback(async () => {
        try {
            const res = await axiosInstance.get("/openapi");
            setItems(res.data);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const { showMessage } = useError();


    const { item, setItem, isLoading, save } = useEntity({
        endpoint: "openApi",
        selectedItem,
        onSuccess: (res) => {
            fetchData();
            setSelectedItem(null);
            setShowKey(res.apiKey);
        }
    });

    const copyKey = (apiKey) => {
        showMessage("Schüssel in Zwischenablage kopiert!");
        navigator.clipboard.writeText(apiKey);
    };

    return (
        <div className="apiKeys">
            <button className="add" onClick={() => setSelectedItem(true)}>API Schlüssel hinzufügen</button>
            <div className="tableWrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Gültig bis</th>
                            <th>Deaktiviert am</th>
                            <th>Zuletzt aufgerufen</th>
                            <th>Erstellt am</th>
                            <th className="options"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((i) => (
                            <tr key={i.id}>
                                <td>{i.name}</td>
                                <td>{i.expiresAt && moment(i.expiresAt).format('L')}</td>
                                <td>{i.revokedAt && moment(i.revokedAt).format('L')}</td>
                                <td>{i.lastUsedAt && moment(i.lastUsedAt).calendar()}</td>
                                <td>{moment(i.createdAt).calendar()}</td>
                                <td className="options">
                                    <div className="controls">
                                        <EditOutlinedIcon onClick={() => setSelectedItem(i.id)} />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {selectedItem !== null && (
                <EditModal
                    title="API Schlüssel"
                    isLoading={isLoading}
                    item={item}
                    onClose={() => setSelectedItem(null)}
                    onSave={save}
                >
                    <div className="group">
                        <ApartmentRoundedIcon />
                        <input
                            type="text"
                            required
                            value={item.name || ""}
                            placeholder="Name"
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    name: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="group">
                        <LockClockRoundedIcon />
                        <input
                            type="date"
                            value={item.expiresAt ? moment(item.expiresAt).format("YYYY-MM-DD") : ""}
                            placeholder="Gültig bis"
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    expiresAt: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="group">
                        <DomainDisabledRoundedIcon />
                        <input
                            type="date"
                            value={item.revokedAt ? moment(item.revokedAt).format("YYYY-MM-DD") : ""}
                            placeholder="Deaktiviert am"
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    revokedAt: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <button type="submit">Speichern</button>
                            <button type="button" className="light" onClick={() => setChangeAccessRights(true)}>Rechte ändern</button>
                        </div>
                    </div>
                </EditModal>
            )}
            {showKey && (
                <EditModal
                    title="API Schlüssel"
                    isLoading={isLoading}
                    onClose={() => setShowKey(null)}
                >
                    <div className="group">
                        <div className="message">
                            <CheckCircleIcon />
                            <span>API Schlüssel wurde erfolgreich erstellt</span>
                        </div>
                    </div>
                    <div className="group" />
                    <div className="group">
                        <p>Der generierte API Schlüssel muss an einem sicheren Ort aufbewahrt werden. Aus Sicherheitsgründen kann der Schlüssel nach dem Schließen dieses Fensters nicht erneut angezeigt werden.</p>
                    </div>
                    <div className="group" />
                    <div className="group">
                        <h5>Generierter Schlüssel</h5>
                    </div>
                    <div className="group">
                        <input type="text" readOnly value={showKey} />
                        <div className="copy" onClick={() => copyKey(showKey)}>
                            <ContentCopyIcon />
                        </div>
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <button onClick={() => setShowKey(null)} className="light">Schließen</button>
                        </div>
                    </div>
                </EditModal>
            )}

            {changeAccessRights && (
                <ChangeApiPermissions
                    id={item.id}
                    onClose={() => setChangeAccessRights(false)}
                />
            )}
        </div>
    )
};

export default ApiKeys